import humps from 'humps';
import { getValidationErrors } from './validation';

export default function CreativeFormValidationService(
  $anchorScroll,
  $location
) {
  const vm = this;

  const DEFAULT_VIDEO_URL =
    'https://legacy-design-assets.s3.amazonaws.com/videos/video-play-here.mp4';

  vm.hasError = hasError;
  vm.isValid = isValid;
  vm.reset = reset;
  vm.shouldShowErrors = false;
  vm.showErrors = showErrors;
  vm.groupIsValid = groupIsValid;

  function showErrors() {
    vm.shouldShowErrors = true;
    $location.hash('creative-preview-form');
    $anchorScroll();
  }

  function reset() {
    vm.shouldShowErrors = false;
  }

  function isValid(creative) {
    const errors = getValidationErrors(humps.decamelizeKeys(creative));
    return errors.length === 0;
  }

  function groupIsValid(group) {
    return group.creativePreviews.every(isValid);
  }

  function hasError(creative, attr) {
    if (!vm.shouldShowErrors) {
      return false;
    }

    // for multiple creatives this is only checking the active creative still
    if (attr === 'thumbnail_url') {
      return !creative.thumbnailUrl;
    } else if (attr === 'media_url') {
      return creative.mediaUrl === DEFAULT_VIDEO_URL;
    } else if (attr === 'advertiser') {
      return !creative.advertiser;
    } else {
      return vm.form[attr] && vm.form[attr].$invalid;
    }
  }

  return vm;
}

CreativeFormValidationService.$inject = ['$anchorScroll', '$location'];
